var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('kst-output',{attrs:{"field":"Name","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"field":"Comment","data":_vm.details,"catalog":_vm.Catalog}}),_c('kst-output',{attrs:{"field":"IsActive","data":_vm.details,"catalog":_vm.Catalog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }